import {
  IWeddingEvent,
  IWeddingEvent2,
} from '@bridebook/models/source/models/Weddings/Events.types';

// This is instead of using an enum, because the model is based on string literals and not enums
// But as we have quite a lot of enums in the codebase, this seems to be somehow simillar to those who don't like strings in the codebase
// Thanks to that, there is no assertions needed when using the event type!!!
export const eventTypeMap = {
  MAIN_EVENT: 'MainEvent',
  CUSTOM_EVENT: 'CustomEvent',
} as const;

export type EventType = IWeddingEvent['type'];

export type WeddingCustomEvent = Extract<IWeddingEvent, { type: 'CustomEvent' }>;
export type WeddingMainEvent = Extract<IWeddingEvent, { type: 'MainEvent' }>;

export type WeddingEvent = WeddingCustomEvent | WeddingMainEvent;

export type CommonWeddingEventFields = Omit<IWeddingEvent2, 'createdAt' | 'updatedAt'> &
  Pick<IWeddingEvent, 'id'>;

type MainEventWithWeddingDetails = WeddingMainEvent & {
  date: string;
  supplier: string;
};

// type for the event that is used in the frontend
export type Event = { type: EventType } & (MainEventWithWeddingDetails | WeddingCustomEvent);

// Type Guards
export const isCustomEvent = (event: WeddingEvent): event is WeddingCustomEvent =>
  event.type === 'CustomEvent';

export const isMainEvent = (event: WeddingEvent): event is WeddingMainEvent =>
  event.type === 'MainEvent';

export type SimplifiedEventForDisplay = Pick<
  Event,
  'id' | 'name' | 'description' | 'date' | 'time' | 'featured' | 'createdAt'
>;

export interface IWeddingEventsState {
  list: Array<IWeddingEvent>;
  loaded: boolean;
}
